import { render, staticRenderFns } from "./StatsAccountantRegistrations.vue?vue&type=template&id=9aa7909e&"
import script from "./StatsAccountantRegistrations.vue?vue&type=script&lang=js&"
export * from "./StatsAccountantRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports